<mat-accordion>
  <mat-expansion-panel [(expanded)]="expanded" class="config-panel">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <h3>General configuration</h3>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <form [formGroup]="parentFormGroup">
      <div class="container-wrap">
        <div class="row-wrap">
          <mat-form-field appearance="fill" class="item">
            <mat-label>ID</mat-label>
            <input matInput formControlName="id" [disabled]="true">
          </mat-form-field>
          <div class="row-wrap">
            <mat-form-field appearance="fill" class="item">
              <mat-label>Navigation Key</mat-label>
              <input matInput formControlName="navigationKey">
            </mat-form-field>
            <mat-form-field appearance="fill" class="item">
              <mat-label>Order position</mat-label>
              <input matInput formControlName="weight" type="number" min="0">
            </mat-form-field>
          </div>
        </div>
        <div class="row-wrap row-wrap-with-color-picker">
          <mat-form-field appearance="fill" class="item">
            <mat-label>Name</mat-label>
            <input matInput formControlName="name" autocomplete="off">
          </mat-form-field>
          <color-picker class="item" [title]="'Set brand color?'"
            [showColorPicker]="sectionConfig.setBrandColor" [hexColor]="sectionConfig.brandColor"
            [parentFormGroup]="parentFormGroup" [controlName]="'brandColor'"
          [showColorPickerControlName]="'setBrandColor'"></color-picker>
        </div>
        <div class="row-wrap row-wrap-with-color-picker">
          <mat-form-field appearance="fill" class="item">
            <mat-label>Localization path</mat-label>
            <input matInput formControlName="localizationPath" autocomplete="off">
            @if (parentFormGroup.hasError('atLeastOne')) {
              <mat-error>The 'Name' and/or 'Localization path' field should be non-empty</mat-error>
            }
          </mat-form-field>
          <color-picker class="item" [title]="'Set background color?'"
            [showColorPicker]="sectionConfig.setBackgroundColor"
            [hexColor]="sectionConfig.backgroundColor" [parentFormGroup]="parentFormGroup"
            [controlName]="'backgroundColor'"
          [showColorPickerControlName]="'setBackgroundColor'"></color-picker>
        </div>
        <div class="row-wrap version-selector-wrap">
          <mat-form-field appearance="fill" class="item">
            <mat-label>Css classes</mat-label>
            <input matInput formControlName="cssClasses" autocomplete="off">
          </mat-form-field>

          <version-selector [controlName]="'versions'" [parentFormGroup]="parentFormGroup" class="item"></version-selector>
        </div>
      </div>
    </form>
  </mat-expansion-panel>
</mat-accordion>
